class LabelAPI{
  static index = () => authenticated => authenticated.get('labels')
  static search = (attributes) => authenticated => authenticated.post('labels/search', {
    data: {
      type: 'labels',
      attributes
    }
  })
}

export default LabelAPI
